module.exports = __webpack_public_path__ + "img/storyset-id-card-rafiki.c8a58f29.svg";